import { LabelTemplateDto } from 'src/store/labelTemplates/labelTemplate';
import { ArrayUtils } from 'src/utils/array';
import {
  LabelTemplateAction,
  LabelTemplateTypes
} from './labelTemplates.actions';

export type LabelTemplatesState = Readonly<{
  labelTemplates: LabelTemplateDto[];
  errors: any;
}>;

const initialState: LabelTemplatesState = {
  labelTemplates: [],
  errors: null
};

const labelTemplatesReducer = (
  state: LabelTemplatesState = initialState,
  action: LabelTemplateAction
) => {
  switch (action.type) {
    case LabelTemplateTypes.FetchAll:
      return { ...state, labelTemplates: action.labelTemplates };
    case LabelTemplateTypes.Add:
      return {
        ...state,
        labelTemplates: [...state.labelTemplates, action.labelTemplate]
      };
    case LabelTemplateTypes.Update:
      return {
        ...state,
        labelTemplates: ArrayUtils.updateListById(
          state.labelTemplates,
          action.labelTemplate
        )
      };
    case LabelTemplateTypes.Delete:
      return {
        ...state,
        labelTemplate: null,
        labelTemplates: ArrayUtils.deleteFromListById(
          state.labelTemplates,
          action.labelTemplate
        )
      };
    case LabelTemplateTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default labelTemplatesReducer;
